export default __webpack_public_path__ + "static/bovag-logo-3765c25809e103b8bc1171eac189fe8f.jpg";